import { loginWithCodeRequest } from "api/auth";
import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { setIsAuth, setProfile } from "store/authSlice";
import { useAppDispatch } from "store/hooks";
import { APP_URL, getAppUrl, getDefaultNetwork } from "utils/defines";
import {
  setLocalStorageAccessToken,
  setLocalStorageItem,
  setLocalStorageRefreshToken,
} from "utils/helpers/localStorage";

const getNetworkFromUrl = (networkCode: string) => {
  let _network = getDefaultNetwork();
  switch (networkCode) {
    case "ATLFR":
      _network = "ATLFR";
      break;
    case "ACVFR":
      _network = "ACVFR";
      break;
    case "YGNBE":
      _network = "YGNBE";
      break;
    case "YGNIT":
      _network = "YGNIT";
      break;
    case "ACVES":
      _network = "ACVES";
      break;
    case "ACVUK":
      _network = "ACVUK";
      break;
    case "HAMUK":
      _network = "HAMUK";
      break;
    case "ACVGABe":
      _network = "ACVGABe";
      break;
    case "IDEAL":
      _network = "IDEAL";
      break;
    case "ACVPL":
      _network = "ACVPL";
      break;
    case "ACVDE":
      _network = "ACVDE";
      break;
    case "ACVCZ":
      _network = "ACVCZ";
      break;
    case "ACVIT":
      _network = "ACVIT";
      break;
    case "ATLPOL":
      _network = "ATLPOL";
      break;
  }

  return _network;
}

export const WSOPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const loginDone = useRef(false);

  useEffect(() => {
    if (
      searchParams.get("code") &&
      searchParams.get("state") &&
      !loginDone.current
    ) {
      loginWithCodeRequest({
        code: searchParams.get("code") || "",
        state: searchParams.get("state") || "",
      }).then((response) => {
        if (response.data.hasError) {
          const jsonState = JSON.parse(atob(searchParams.get("state") as any));
          const _network = getNetworkFromUrl(jsonState.NetworkCode);
          navigate(
            getAppUrl(APP_URL.Login, { network: _network })
          );
        } else {
          dispatch(setProfile(response.data));
          dispatch(setIsAuth(true));
          setLocalStorageAccessToken(response.data.accessToken);
          setLocalStorageRefreshToken(response.data.refreshToken);
          setLocalStorageItem("loginState", searchParams.get("state"));
          const _network = getNetworkFromUrl(response.data.networkCode);
          navigate(getAppUrl("/", { network: _network }));
        }
      });
    }
    loginDone.current = true;
  }, []);

  return <>Signing in...</>;
};
